import { createFileRoute } from '@tanstack/react-router';
import { JourneysBroadcastsHandoff } from '@/pages/workspaces/broadcasts/routing';
import { AppBundle } from '@/utils/app-bundles';
import { LastWorkspaceResolver } from './-components';

/**
 * The legacy Send volume tab URL. It forwards to the migrated list. The resolver belongs here: this
 * URL keeps the `journeys` segment, so a `/workspaces/last` sentinel resolves against the embedded
 * app's bundle before the forward builds its target.
 */
function JourneysBroadcastsSendVolumeRoute() {
  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      <JourneysBroadcastsHandoff tab="send-volume" />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/broadcasts/send-volume')({
  component: JourneysBroadcastsSendVolumeRoute,
});
